export function mxfOperationalPatternName(operationalPattern: string): string | null {
  const pattern : RegExp = /^06\.0e\.2b\.34\.04\.01\.01\.[0-9a-f]{2}\.0d\.01\.02\.01\./;
  if (pattern.exec(operationalPattern) === null) {
    return null;
  }

  const bytes = operationalPattern.split('.');
  let itemComplexity : string;
  switch (bytes[12]) {
    case '01':
      itemComplexity = '1';
      break;
    case '02':
      itemComplexity = '2';
      break;
    case '03':
      itemComplexity = '3';
      break;
    default:
      return null;
  }

  let packageComplexity : string;
  switch (bytes[13]) {
    case '01':
      packageComplexity = 'a';
      break;
    case '02':
      packageComplexity = 'b';
      break;
    case '03':
      packageComplexity = 'c';
      break;
    default:
      return null;
  }

  return `OP${itemComplexity}${packageComplexity}`;
}
